import { FetchUsersRoutine } from '../redux-routines';

const initialState = {
  isFetching: false,
  data: [],
  error: null
};

export const usersListReducer = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case FetchUsersRoutine.SUCCESS:
      return {
        ...state,
        isFetching: false,
        data: action.payload,
        error: null
      };
    case FetchUsersRoutine.REQUEST:
      return {
        ...state,
        isFetching: true,
        error: null
      };
    case FetchUsersRoutine.FAILURE:
      return {
        ...state,
        isFetching: false,
        error: action.payload
      };

    default:
      return state;
  }
};